/* eslint-disable @typescript-eslint/naming-convention */
import type { Nullable } from '../../types';
import { HTTPError } from '../error';

export default class UserBasicData {
  firstName: Nullable<string>;

  lastName: Nullable<string>;

  email: Nullable<string>;

  password: Nullable<string>;

  constructor({
    firstName = null,
    lastName = null,
    email = null,
    password = null,
  }: {
    firstName?: Nullable<string>;
    lastName?: Nullable<string>;
    email?: Nullable<string>;
    password?: Nullable<string>;
  }) {
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.password = password;
  }

  toRequestData(): {
    first_name: Nullable<string>;
    last_name: Nullable<string>;
    email: string;
    password: string;
  } {
    if (this.password == null || this.email == null) {
      throw HTTPError.invalidData();
    }

    return {
      first_name: this.firstName,
      last_name: this.lastName,
      email: this.email,
      password: this.password,
    };
  }

  toSearchParams(): URLSearchParams {
    const searchParams = new URLSearchParams();

    if (this.firstName != null) {
      searchParams.append('first_name', this.firstName);
    }

    if (this.lastName != null) {
      searchParams.append('last_name', this.lastName);
    }

    if (this.email != null) {
      searchParams.append('email', this.email);
    }

    if (this.password != null) {
      searchParams.append('password', this.password);
    }

    return searchParams;
  }
}
